import http from "../http-common";

class CleaningDetailService {
  getAll(params = {}) {
    return http.get("/cleaning-details", { params });
  }

  get(id) {
    return http.get(`/cleaning-details/${id}`);
  }

  create(data) {
    return http.post("/cleaning-details", data);
  }

  update(id, data) {
    return http.put(`/cleaning-details/${id}`, data);
  }

  delete(id) {
    return http.delete(`/cleaning-details/${id}`);
  }
}

export default new CleaningDetailService();
